import React from "react";
import tw from "twin.macro";
import styled from "styled-components";

const Wrap = styled.div`
  ${tw`mx-auto px-[15px] w-full`}
`;
const Heading = styled.section`
  ${tw`flex flex-row items-center my-[30px]`}
`;
const Content = styled.div`
  ${tw`flex-1`}
`;

const Sorry = () => (
  <React.Fragment>
    <Wrap>
      <Heading>
        <Content>
          <h5>Sorry, there are no groups in your area... yet!</h5>
        </Content>
      </Heading>
    </Wrap>

    <Wrap>
      <p>Check back for more opportunities soon!</p>
    </Wrap>
  </React.Fragment>
);

export default Sorry;
